module.exports = __webpack_public_path__ + "img/background10.6e771f6f.png";